export default __webpack_public_path__ + "static/media/tile_WXTropical.0371474a.svg";